// Scripts
import Swiper from 'swiper'
import { Autoplay, EffectFade, Pagination } from 'swiper/modules'

// Styles
import 'swiper/css/bundle'
import '../../scss/components/swiper'
import '../../scss/components/homeHero'

// Modules Swiper à utiliser
Swiper.use([Autoplay, EffectFade, Pagination])

// éléments contenant les carrousels
const els = document.querySelectorAll('.homeHeroSlider')
for (const swiper of els) {
  const container = swiper.querySelector('.swiper')
  if (container && !container.classList.contains('swiper-initialized')) {
    const defaults = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      preloadImages: false,
      lazy: {
        loadOnTransitionStart: true
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000
      },
      on: {
        lazyImageReady (swiper, slide, img) {
          // https://github.com/nolimits4web/swiper/issues/5667
          if (img.complete) {
            swiper.update()
          } else {
            img.addEventListener('load', () => {
              swiper.update()
            })
          }
        }
      }
    }
    const slider = new Swiper(container, defaults)
    slider.init()
  }
}
